export default "__VITE_ASSET__fdfbc514__"